import React from "react";

export default function Spinner() {
  return (
    <div className="spinner-container">
      <div className="spinner">
        <div className="bar1" />
        <div className="bar2" />
        <div className="bar3" />
      </div>
    </div>
  );
}
